import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { isIOS } from '../utils/utils';
import { storeLinks } from '../utils/constants';

const DownloadClientPage = () => {
  useEffect(() => {
    const isIOSDevice = isIOS();
    window.location.assign(isIOSDevice ? storeLinks.apple.client : storeLinks.android.client);
  }, []);

  return <Navigate to='/' />;
};

export default DownloadClientPage;
